import { Component, OnInit, ViewChild } from '@angular/core';
import { ApiMethod } from '../../apimethods/api-method';
import { Article_TypeAPIModel } from './article-type-model';
import { ActivatedRoute, Router } from '@angular/router';
import * as ngswal from "sweetalert";
import { DataParam, customfunctions } from '../../common/customfunctions';
import { GlobalConstants } from '../../common/global-constants';
declare var $;

@Component({
  selector: 'app-article-type',
  templateUrl: './article-type.component.html',
  styleUrls: ['./article-type.component.css']
})
/** Article-Type component*/
export class ArticleTypeComponent implements OnInit {
  modelItem = new Article_TypeAPIModel();
  @ViewChild('dataTable', { static: false }) table: { nativeElement: any; }
    dataSet: string;
    dataTable: any;
    title: string;
    popUpButtonText: string;
  /** Article-Type ctor */
  ngOnInit(): void {
    ApiMethod.getBaseUrl();
  }
  constructor(private router: Router, private route: ActivatedRoute) {
    ApiMethod.getPageConfig().subscribe(
      data => {
        this.modelItem = <Article_TypeAPIModel>data["ArticleTypePage"];
        this.MainGridTable();

      }, error => {
        ngswal("Warning !", error.message, "warning");
      });
  }
  //Grid Show 
  MainGridTable() {
    $("LoadingImage").show();

    var dataparam = {
      LoginID: localStorage.aLoginID,
      PublisherID: localStorage.aPubID,
      ModuleName: "ArticleTypesModule"
    }


    ApiMethod.postMethod(this.modelItem.GetTypeColumn, dataparam).subscribe(
      Response => {
        this.dataSet = JSON.stringify(Response.aitemList); // Data List
        this.dataSet = JSON.parse(this.dataSet);
        this.dataTable = $(this.table.nativeElement);

        //Dynamic datable
        let aColList = Response.acolListL; // grid column data
        let dataItem = new DataParam();
        dataItem.acolList = aColList;
        dataItem.dataTable = this.dataTable;
        dataItem.dataset = this.dataSet;
        dataItem.dtheight = (GlobalConstants.size.height - 150);
        dataItem.modulename = 'ArticleTypesModule';
        dataItem.aNewButtonName = 'BtnPopup';
        dataItem.isDefault = false;
        this.dataTable = customfunctions.dynamicDataTable(dataItem);
        //Dynamic datable

        $("LoadingImage").hide();
      }, error => {
        $("#LoadingImage").hide();
        ngswal("Failed !", error.message, "error");
      });
  }

  // Show
  GetArticleTypeById() {
    $("LoadingImagePopup").show();
    this.ClearData();
    $('#btnPopupartDetails').show();


    if (localStorage.aEID != 0) {
      ApiMethod.getMethod(this.modelItem.GetArticleTypeById + "/" + localStorage.aEID).subscribe(
        Response => {
          var aitems = Response.articleType;
          console.log(Response.articleType);
       
          $('#txtArticleTypeName').val(aitems[0].TypeName);
          $('#txtArticleTypeCode').val(aitems[0].TypeCode);
          $('#Txt_DisplayOrder').val(aitems[0].DisplayOrder);
          if (aitems[0].ReopenCorrection == 1) {
            $('#chkReopenCorrection').prop('checked', true);
          } else {
            $('#chkReopenCorrection ').prop('checked', false);
          }

          if (aitems[0].PdfMerge == 1) {
            $('#chkPdfMerge').prop('checked', true);
          } else {
            $('#chkPdfMerge').prop('checked', false);
          }
          if (aitems[0].NoNeedPDF == 1) {
            $('#chkNoNeedPDF').prop('checked', true);
          } else {
            $('#chkNoNeedPDF').prop('checked', false);
          }
          if (aitems[0].DirectDelivery == 1) {
            $('#chkDirectDelivery').prop('checked', true);
          } else {
            $('#chkDirectDelivery').prop('checked', false);
          }
          this.title = " Type Name : " + aitems[0].TypeName + " ";
          this.popUpButtonText = "Update";
          $("LoadingImagePopup").hide();
        },
        error => {
          $("#LoadingImagePopup").hide();
          ngswal("Failed !", error.message, "error");
        });
    } else {
      //show popup
      $('#btnPopupartDetails').show();

      //Title and button Values
      this.popUpButtonText = "Add";
      this.title = " Add Article Type ";
      localStorage.aEID = "";
      $("LoadingImagePopup").hide();
    }
  }
  // Add Update 
  AddUpdateArticleType(): void {
    //Validation 
    if ($('#txtArticleTypeName').val().trim() == '') {
      ngswal("Warning !", "Enter Type Name!", "warning");
    }
    else if ($('#txtArticleTypeCode').val().trim() == '') {
      ngswal("Warning !", "Enter Article Type Code!", "warning");
    }
    
    else {
      //Getting Updated value
      $("#LoadingImagePopup").hide();
      var chkReopenCorrection = $('#chkReopenCorrection').prop('checked');
      if (chkReopenCorrection == true) {
        chkReopenCorrection = 1;
      } else {
        chkReopenCorrection = 0;
      }

      var chkPdfMerge = $('#chkPdfMerge').prop('checked');
      if (chkPdfMerge == true) {
        chkPdfMerge = 1;
      } else {
        chkPdfMerge = 0;
      }
      var chkNoNeedPDF = $('#chkNoNeedPDF').prop('checked');
      if (chkNoNeedPDF == true) {
        chkNoNeedPDF = 1;
      } else {
        chkNoNeedPDF = 0;
      }
      var chkDirectDelivery = $('#chkDirectDelivery').prop('checked');
      if (chkDirectDelivery == true) {
        chkDirectDelivery = 1;
      } else {
        chkDirectDelivery = 0;
      }
      var dataparam = {
        SNo: localStorage.aEID,
        TypeName: $('#txtArticleTypeName').val(),
        TypeCode: $('#txtArticleTypeCode').val(),
        DisplayOrder: $('#Txt_DisplayOrder').val(),
        ReopenCorrection: chkReopenCorrection,
        PdfMerge: chkPdfMerge,
        NoNeedPDF: chkNoNeedPDF,
        DirectDelivery: chkDirectDelivery
        

      };

      ApiMethod.postMethod(this.modelItem.AddUpdateArticleType, dataparam).subscribe(
        response => {
          this.MainGridTable();
          $("#LoadingImagePopup").hide();
          this.hide();
          ngswal({
            position: 'top-end',
            type: "success",
            title: "Updated !",
            text: response.addEditArticleType,
            showConfirmButton: true,

          });

        },
        error => {
          ngswal("Failed !", error.Message, "warning");
          $("#LoadingImagePopup").hide();
        }
      );
    }
  }

  // Delete Confirmation  Pop-up 
  DeleteArticleType() {

    ngswal({
      title: "Are you confirm to delete Article Type Details?",
      text: "Article Type Details deleted permenently!",
      type: "info",
      showCancelButton: true,
      confirmButtonColor: "#DD6B55",
      confirmButtonText: "Yes, Delete!",
      cancelButtonText: "No, Cancel!",
      closeOnConfirm: false,
      closeOnCancel: false
    },
      function (isConfirm) {
        if (isConfirm) {
          $('#btnDeleteConfirm').trigger("click");
        } else {
          ngswal("Cancelled", "Your data is safe :)", "warning");
          return false;
        }
      });
  }
  // Delete the Id
  DeleteConfirm() {
    $('#LoadingImagePopup').show();

    ApiMethod.getMethod(this.modelItem.DeleteArticleType + localStorage.aEID).subscribe(
      result => {
        this.MainGridTable();
        $("#LoadingImagePopup").hide();
        this.hide();
        ngswal({
          position: 'top-end',
          type: "success",
          title: "Deleted Successfully!",
          text: result.deleteMsg,
          showConfirmButton: false,
          timer: 1500
        });
      }, error => {
        $("#LoadingImagePopup").hide();
        ngswal("Failed !", error.message, "warning");
      });
  }

  hide() {
    this.ClearData();
    $('#btnPopupartDetails').hide();
  }
  ClearData(): void {
    $('#txtArticleTypeName').val('');
    $('#Txt_DisplayOrder').val('');
    $('#txtArticleTypeCode').val('');
    $('#chkReopenCorrection').prop('checked', false);
    $('#chkPdfMerge').prop('checked', false);
    $('#chkNoNeedPDF').prop('checked', false);
    $('#chkDirectDelivery').prop('checked', false);

  } 

}
